<template>
  <div class="PlatformWrap">
    <div class="SwiperWrap">
      <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
      <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img4.jpg"></swiper-slide>
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img1.jpg"></swiper-slide>
        <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img3.jpg"></swiper-slide>
        <div class="swiper-pagination flex" slot="pagination"></div>
      </swiper>
      <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
    </div>
    <div class="LineContentWrap">
      <img src="../../assets/Home/line.jpg">
    </div>
    <div class="ListContetnWrap">
      <ul class="clearfix">
        <li v-for="(item, index) in platformList" :key="'platform' + index">
          <div class="IconWrap" @click="OpenSenchaBox(item.type)">
            <img :src="item.icon">
            <p>{{ item.name }}</p>
          </div>
          <div class="TextOpen">
            <div class="TextWrap">
              <p>{{ item.name }}</p>
              <p>{{ item.info }}</p>
            </div>
            <div class="flex Go"><span>进入</span></div>
          </div>
        </li>
        <!--              <li>-->
        <!--                    <div class="IconWrap">-->
        <!--                        <img src="../../assets/Home/icon11.png">-->
        <!--                        <p>GE认证平台</p>-->
        <!--                    </div>-->
        <!--                    <div class="TextWrap">-->
        <!--                        <p>统一认证和管理平台所有服务资源，包括:人员、企业、设备、软件等，统一注册、统一认证和统一管理所有平台资源可信数据。</p>-->
        <!--                    </div>-->
        <!--                    <div class="flex Go"  @click="OpenSenchaBox('authentication')">》<span>进入</span>《</div>-->
        <!--                </li>-->
      </ul>
    </div>
    <div class="BeiAn flex">
      <p @click="OpenUrl('https://beian.miit.gov.cn')">京ICP备13044163号-1</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {
  name: 'platform',
  components: {},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1.13,
        centeredSlides: true,
        spaceBetween: 15,
        initialSlide: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      platformList: [/* {
                         name: 'GE认证平台',
                         icon: require('../../assets/Home/icon11.png'),
                         info: '统一认证和管理平台所有服务资源，包括:人员、企业、设备、软件等，统一注册、统一认证和统一管理所有平台资源可信数据。',
                         type: 'authentication'
                       }, */ /* {
          name: 'GE配置平台',
          icon: require('../../assets/Home/icon9.png'),
          info: '配置平台用于配置SaaS产品的专属应用系统，充分体现了工易SaaS平台由用户自己配置个性化应用的能力，自我适应企业个性化和变化。平台拥有组织管理器、作业岗位管理器、流程配置器和规则配置器。',
          type: 'manager'
        }, {
          name: 'GE运营平台',
          icon: require('../../assets/Home/icon10.png'),
          info: '运营平台由3个门户和七大板块构成，3个门户包括：WEB门户、APP门户和微信门户，七大板块包括工作、发现、云服务、即时通讯、消息服务、个人中心和工 易云(云服务入口)。',
          type: 'normal'
        }, */{
          name: '智 能 建 模',
          icon: require('../../assets/Home/h-1.png'),
          info: '为平台注册企业提供专属应用系统配置开发，根据平台的业务变化可以快速迭代系统，适应平台高速发展的需要。',
          type: 'model'
        },
        {
          name: '配 置 平 台',
          icon: require('../../assets/Home/icon9.png'),
          info: '配置平台用于配置SaaS产品的专属应用系统，充分体现了工易SaaS平台由用户自己配置个性化应用的能力，自我适应企业个性化和变化。平台拥有组织管理器、作业岗位管理器、流程配置器和规则配置器。',
          type: 'manager'
        },
        {
          name: '智 能 运 营',
          icon: require('../../assets/Home/icon13.png'),
          info: '为平台注册企业提供专属智能模型，根据平台的业务变化可以快速迭代系统，适应平台高速发展的需要。',
          type: 'aitest'
        },

        {
          name: '测 试 平 台',
          icon: require('../../assets/Home/icon12.png'),
          info: '为平台注册企业提供专属实验系统配置开发，根据平台的业务变化可以快速迭代系统，适应平台高速发展的需要。',
          type: 'test'
        },
        {
          name: '工 易 GPT',
          icon: require('../../assets/Home/goeasyChat.png'),
          info: 'GPT是一种基于互联网的、可用数据来训练的、文本生成的深度学习模型。',
          type: 'gptplatform'
        },
        {
          name: '智 能 运 营 Dark',
          icon: require('../../assets/Home/icon13.png'),
          info: '为平台注册企业提供专属智能模型，根据平台的业务变化可以快速迭代系统，适应平台高速发展的需要。',
          type: 'aitestDark'
        }
          // {
          //   name: '协 同 平 台',
          //   icon: require('../../assets/Home/xiezuo.png'),
          //   info: '分布式协同技术是解决产业链相关联业务异构系统之间作业协同的技术方案。',
          //   type: 'xietong'
          // },
          // {
          //   name: '建 模 平 台',
          //   icon: require('../../assets/Home/saas_icon.png'),
          //   info: '所见即所得的可视化业务建模工具，面向用户提供图形化设计语言， 方便用户梳理业务流程及业务规则，构建完善的业务模型。',
          //   type: 'build'
          // },
          /* {
          name: 'GE测试平台',
          icon: require('../../assets/Home/h-2.png'),
          info: '为应用产品开发提供测试服务,通过配置测试环境和模拟使用场景,为应用产品开发和测试人员提供完善的单元测试、集成测试等功能。',
          type: 'test'
        }, {
          name: 'GE监控平台',
          icon: require('../../assets/Home/h-3.png'),
          info: '对工易云PaaS平台管理器工具和SaaS平台应用产品运行所需的软、硬件环境进行实时监控、预警和管理，保障系统稳定运行。',
          type: 'jiankong'
        } */]
    };
  },
  computed: {
    ...mapGetters(['LoginUserInfo', 'currentSystem'])
  },
  methods: {
    OpenUrl(url) {
      window.open(url, '_blank');
    },
    OpenSenchaBox(type) {
      // debugger;
      // if (type === 'model' || type === 'build') {
      //   this.$store.dispatch('setplatformname', '建模平台');
      // } else if (type === 'authentication' || type === 'normal' || type === 'manager' || type === 'test') {
      //   this.$store.dispatch('setplatformname', '运营平台');
      // }
      if (type === 'model') {
        this.$store.dispatch('setplatformname', '智能建模');
      } else if (type === 'build') {
        this.$store.dispatch('setplatformname', '建模平台');
      } else if (type === 'xietong') {
        this.$store.dispatch('setplatformname', '协同平台');
      } else if (type === 'manager') {
        this.$store.dispatch('setplatformname', '配置平台');
      } else if (type === 'authentication' || type === 'normal' || type === 'test') {
        this.$store.dispatch('setplatformname', '运营平台');
      } else if (type === 'gptplatform') {
        this.$store.dispatch('setplatformname', '工易GPT');
      } else if (type === 'test') {
        this.$store.dispatch('setplatformname', '测试平台');
      } else if (type === 'aitest') {
        this.$store.dispatch('setplatformname', '智能运营');
      } else if (type === 'aitestDark') {
        this.$store.dispatch('setplatformname', '智能运营Dark');
      } 
      if (this.LoginUserInfo.userId) {
        if (type === 'authentication' || type === 'normal') { // 认证 运营
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'build') { // 建模
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'model') { // 平台 配置
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'test') { // 平台 测试
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'aitest' || type === 'aitestDark') { // 平台 智能体测试
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'gptplatform') { // 平台 配置
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        } else if (type === 'manager') { // 平台 配置
          axios({
            method: 'GET',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: this.$loginUrl + 'api/login/getnewtoken', // ?userid=50018,b86a7eb3-beff-4f49-9fb7-3abedc928661.杨福华0&eom=00326',
            params: {
              userid: this.LoginUserInfo.userId, // + '.' + this.LoginUserInfo.username,
              identity: type,
              eomid: this.currentSystem.code,
              getportal: '1',
              changeeom: '1'
            }
          }).then((res) => {
            if (res.data.code === 0) {
              this.$store.dispatch('togglesenchabox', true);
              window.GEVAR.MainController.addInitPage({ user: [res.data.data.user], platform: type, data: res.data.data, code: this.currentSystem.code, name: this.currentSystem.name });
            } else if (res.data.code === -1) {
              let errormsg = res.data.msg || '对应操作无效';
              this.$alert(errormsg, '提示', {
                confirmButtonText: '确定'
              });
            }
          });
        } else if (type === 'xietong') { // 协同平台
          this.$store.dispatch('togglesenchabox', true);
          window.GEVAR.MainController.addInitPage({ user: [this.LoginUserInfo], platform: type, code: this.currentSystem.code, name: this.currentSystem.name });
        }
      } else {
        this.$emit('OpenLoginBox');
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../../public/Value';

.PlatformWrap {
  width: 100%;

  .BeiAn {
    width: 90%;
    margin: 0.1rem auto 0;
    padding: 0.1rem 0;
    border-radius: 0.05rem;
    background-color: #232323;

    p {
      font-size: $TextSize;
      color: #fff;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  .SwiperWrap {
    width: 100%;
    height: 1.3rem;
    position: relative;
    overflow: hidden;

    .swiper-pagination {
      width: 100%;
      height: 0.1rem;
      position: absolute;
      bottom: 0.02rem;

      ::v-deep .swiper-pagination-bullet-active {
        background-color: #fff !important;
      }

      ::v-deep .swiper-pagination-bullet {
        width: 0.15rem;
        height: 0.02rem;
        opacity: 1;
        margin: 0 0.02rem;
        background-color: #4d4d4d;
        border-radius: 0.03rem;
      }
    }

    .LeftShadow,
    .RightShadow {
      height: 100%;
      position: absolute;
      z-index: 2;

      img {
        height: 100%;
        transform: scale(1.1);
      }
    }

    .LeftShadow {
      left: -0.1rem;
      top: 0;
    }

    .RightShadow {
      right: -0.1rem;
      top: 0;
    }

    .SwiperList {
      width: 100%;
      height: 100%;

      .ImgWrap {
        border-radius: 0.1rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 0.1rem;
        }
      }
    }
  }

  .LineContentWrap {
    width: 84%;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .ListContetnWrap {
    width: 90%;
    margin: 0 auto;

    ul {
      width: 100%;

      li {
        float: left;
        width: 1.05rem;
        height: 1.05rem;
        margin-right: 2%;
        margin-bottom: 2%;
        position: relative;
        cursor: pointer;

        .Go {
          width: 0.38rem;
          height: 0.12rem;
          font-size: $TextSize;
          position: absolute;
          left: 50%;
          margin-left: -0.19rem;
          bottom: 0.05rem;
          color: #fff;
          background-color: #886fb2;
          border-radius: 0.2rem;
          cursor: pointer;
        }

        .IconWrap {
          width: 100%;
          height: 100%;
          border-radius: 0.1rem;
          background: linear-gradient(to Right Bottom, #983333, #751b1b);
          position: absolute;
          left: 0;
          top: 0;
          z-index: 3;
          transition: all 0.5s;
          opacity: 1;

          p {
            text-align: center;
            color: #fff;
            font-size: $AdditionTextSize;
            margin-top: 0.05rem;
            font-weight: bold;
          }

          img {
            height: 0.2rem;
            margin: 0 auto;
            margin-top: 0.35rem
          }
        }

        .TextOpen {
          width: 100%;
          height: 100%;
          position: absolute;
          transition: all 0.5s;
          top: 0;
          left: 0;
          z-index: 2;
          opacity: 0;

          .TextWrap {
            width: 78%;
            margin: 0 auto;
            padding-top: 0.06rem;

            p {
              font-size: $SmallTextSize;
              color: #fff;
              line-height: 0.08rem;
            }

            p:first-child {
              font-size: $TextSize;
              margin-bottom: 0.03rem;
            }
          }
        }
      }

      li:hover {
        .IconWrap {
          opacity: 0.2;
        }

        .TextOpen {
          opacity: 1;
        }
      }

      li:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
